import { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { FlexColumn, Gap } from 'ui-components/components/flex';
import { NumberInput } from 'ui-components/components/number-input';
import { Text, TextType } from 'ui-components/components/text';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import { messages } from './messages';
import styles from './styles.module.less';
import ProductAutoComplete from '../../../../../../../../../components/product-auto-complete';
import { bulkLoadProducts } from '../../../../../../../../../store/products/products.api';
import { INT_PARAMETER, PARAMETER } from '../../../../../../constants/parameter-name-for-update';

/**
 * @param {object} props
 * @param {(rule: object) => void} props.onChange
 * @param {{parameter?: string, intParameter?: number}} props.inputValueProps
 * @returns {React.JSX.Element}
 */
export const AddShipmentItem = ({ onChange, inputValueProps }) => {
  const [product, setProduct] = useState({
    name: '',
  });

  const [searchTerm, setSearchTerm] = useAsyncSafeState(product.name || '');

  useEffect(() => {
    const fetch = async () => {
      try {
        const response = await bulkLoadProducts([inputValueProps.parameter]);
        const fetchedProduct = response.products[0];
        setProduct(fetchedProduct);
        setSearchTerm(fetchedProduct.name);
      } catch {
        setProduct({
          name: '',
        });
      }
    };
    if (inputValueProps.parameter) {
      fetch();
    }
  }, [inputValueProps.parameter, setSearchTerm]);

  const { formatMessage } = useIntl();

  const onSelectionMade = useCallback(
    (selectedProduct) => {
      setSearchTerm(selectedProduct.name);
      onChange({
        [PARAMETER]: selectedProduct.productId,
      });
    },
    [setSearchTerm, onChange],
  );

  const onQuantityChange = useCallback(
    (quantity) => {
      onChange({
        [INT_PARAMETER]: quantity,
      });
    },
    [onChange],
  );

  return (
    <div className={styles.wrapper}>
      <FlexColumn gap={Gap.Space4}>
        <Text htmlFor='product-input' textType={TextType.Label} value={messages.productLabel} />
        <ProductAutoComplete
          ariaLabel={formatMessage(messages.productSearch)}
          className={styles['searchable-input']}
          id='product-input'
          keepInputEnabled
          onSelectionMade={onSelectionMade}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
      </FlexColumn>
      <FlexColumn gap={Gap.Space4}>
        <Text htmlFor='quantity-input' textType={TextType.Label} value={messages.quantityLabel} />
        <NumberInput
          className={styles['quantity-input']}
          id='quantity-input'
          min={1}
          onChange={onQuantityChange}
          value={inputValueProps.intParameter || 1}
        />
      </FlexColumn>
    </div>
  );
};
